(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FALLBACK = "https://www.instagram.com/";

    function enhance(root) {
      var profile = root.getAttribute("data-ig-profile") || FALLBACK;
      var images = root.querySelectorAll("img");

      for (var i = 0; i < images.length; i++) {
        var img = images[i];

        // Carga diferida y decodificacion asincrona (rendimiento)
        if (!img.getAttribute("loading")) img.setAttribute("loading", "lazy");
        if (!img.getAttribute("decoding")) img.setAttribute("decoding", "async");
        if (!img.getAttribute("fetchpriority")) img.setAttribute("fetchpriority", "low");

        // Ninguna imagen se queda sin enlace
        var wrapper = img.closest("a");
        if (!wrapper) {
          wrapper = document.createElement("a");
          wrapper.href = profile;
          wrapper.target = "_blank";
          wrapper.rel = "noopener noreferrer";
          wrapper.className = "ig-fallback-link";
          wrapper.setAttribute("aria-label", "Ver en Instagram");
          img.parentNode.insertBefore(wrapper, img);
          wrapper.appendChild(img);
        }
      }

      var links = root.querySelectorAll("a[href]");
      for (var j = 0; j < links.length; j++) {
        var link = links[j];
        var href = link.getAttribute("href") || "";

        // Distintivo para Reels y videos
        if (href.indexOf("/reel") > -1 || href.indexOf("/tv/") > -1 || link.querySelector("video")) {
          link.classList.add("ig-is-reel");
        }

        if (!link.getAttribute("target")) {
          link.setAttribute("target", "_blank");
          link.setAttribute("rel", "noopener noreferrer");
        }

        if (!link.getAttribute("aria-label")) {
          link.setAttribute("aria-label", "Ver esta publicación en Instagram");
        }
      }
    }

    function init() {
      var roots = document.querySelectorAll("[data-ig-feed]");

      for (var k = 0; k < roots.length; k++) {
        (function (root) {
          enhance(root);

          if (!window.MutationObserver) return;

          var timer;
          var observer = new MutationObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              enhance(root);
            }, 80);
          });

          observer.observe(root, { childList: true, subtree: true });
        })(roots[k]);
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
